import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import {STICKY_HEADER_SCROLL_TRIGGER} from "../../../../config/constants"

export const RelativeContainer = styled("div")`
    min-height: ${STICKY_HEADER_SCROLL_TRIGGER}px;
    width: 100%;
    position: relative;
    z-index: 4;
    height: 3.5rem;
    @media (min-width: ${breakpoints.values.lg}px) {
        display: none;
    }
`
